import React, { useEffect, useState } from "react";
import { Stack } from "@mui/material";
import { connect } from "react-redux";

import { HubHookFormWrapper } from "../../components";
import {
  useGetQuoteDetails,
  usePostQuote,
  usePutQuote,
} from "../../hooks/react-query/useSalesData";
import { getIsDialogOpen, setIsOpenDialog } from "../../redux/dialogs";

import QuoteDialogForm from "./QuoteDialogForm";
import QuoteTimeline from "./QuoteTimeline";
import QuoteBar from "./QuoteBar";
import { mapQuotePayload, mapQuoteDefaults } from "./helper";

import { StyledDrawer } from "./styles";

const DIALOG_NAME = "edit-quote";

const QuoteDrawer = ({ open, _setIsOpenDialog = () => {} }) => {
  const isNew = open === true;
  const id = !isNew && open ? Number(open) : null;

  const { data: quote } = useGetQuoteDetails(id);
  const { mutate: create, isSuccess: isCreateSuccess } = usePostQuote();
  const { mutate: update, isSuccess: isUpdateSuccess } = usePutQuote();

  const onClose = () => {
    _setIsOpenDialog(DIALOG_NAME, false);
  };
  const isSuccess = isCreateSuccess || isUpdateSuccess;

  useEffect(() => {
    if (isSuccess && isNew) onClose();
  }, [isSuccess, isNew]);

  const handleSubmit = (data) => {
    const payload = mapQuotePayload(data);
    if (isNew) create(payload);
    else update({ id, ...payload });
  };

  const defaultValues = mapQuoteDefaults(isNew ? null : quote);

  return (
    <StyledDrawer anchor="right" open={!!open} onClose={onClose}>
      <HubHookFormWrapper
        defaultValues={defaultValues}
        onSubmit={handleSubmit}
        sx={{ height: "100%" }}
      >
        <Stack overflow="hidden" height="100%">
          <QuoteBar onClose={onClose} />
          <Stack
            height="100%"
            sx={{
              overflowY: "auto",
              "::-webkit-scrollbar": {
                display: "none !important",
              },
            }}
          >
            <QuoteDialogForm />
            {!isNew && quote && (
              <Stack padding="0 20px 20px">
                <QuoteTimeline quoteId={quote?.id} />
              </Stack>
            )}
          </Stack>
        </Stack>
      </HubHookFormWrapper>
    </StyledDrawer>
  );
};

const mapStateToProps = (state) => ({
  open: getIsDialogOpen(state, DIALOG_NAME),
});
const mapDispatchToProps = { _setIsOpenDialog: setIsOpenDialog };

export const QuoteDialog = connect(
  mapStateToProps,
  mapDispatchToProps,
)(QuoteDrawer);

export default QuoteDialog;
